import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { EventInfo } from '../../../objects/EventInfo';
import { PlayerService } from '../../../services/player.service';
import { EventService } from '../../../services/event.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GroupSettings } from '../../../objects/group-settings';
import { GroupService } from '../../../services/group.service';
import { MembershipLevel } from '../../../objects/membership-level';
import { MessageService } from '../../../services/email.service';
import { PaymentFormComponent } from '../../../components/payment-form/payment-form.component';
import { EmailDialogComponent } from '../../../components/email-dialog/email-dialog.component';
import { catchError } from 'rxjs/operators';
import { NewEventDialogComponent } from 'src/app/modules/shared/new-event-dialog/new-event-dialog.component';


declare let dataLayer: any;

@Component({
  selector: 's18-event-summary',
  templateUrl: './event-summary.component.html',
  styleUrls: ['./event-summary.component.scss']
})
export class EventSummaryComponent implements OnInit {
  @Input() eventInfo: EventInfo;
  @Input() short: boolean = false;

  @Output() paymentStatusUpdated = new EventEmitter<string>();

  canEditEvent: boolean = false;
  requestSent: boolean = false;
  masterEvent: EventInfo;
  eventPaymentStatus: string;
  settings: GroupSettings;
  error: string ='';
  eventList: EventInfo[] = [];
  

  constructor(
    private router: Router,
    private playerService: PlayerService,
    private eventService: EventService,
    private groupService: GroupService,
    private messageService: MessageService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) {
    
   }

  ngOnInit() {
    this.canEditEvent = this.playerService.isPlayerGroupAdmin(+this.eventInfo.group_id);
    if ( this.isRoundOfMultiRound() ){
      this.eventService.getEventBasics(this.eventInfo.multi_round_id)
        .subscribe( resp => {
          this.masterEvent = JSON.parse(resp.d).group_event;
          this.fetchRounds();
        })
    }
    this.updatePaymentStatus();
    this.groupService.getGroupSettings(this.eventInfo.group_id)
      .subscribe( resp => this.settings = JSON.parse(resp.d)[0]);
  }

  updatePaymentStatus(){
    this.eventService.getGroupEventPaymentStatus(this.eventInfo.group_id, this.eventInfo.group_event_id)
      .subscribe( resp =>{
        this.eventPaymentStatus = JSON.parse(resp.d).eventPaymentStatus;
        console.log(JSON.parse(resp.d));
      });
  }

  sendNote(){
    let dialogRef = this.dialog.open(EmailDialogComponent, {
      width: '850px',
      data: {
        groupId: this.eventInfo.group_id,
        groupEventId: +this.eventInfo.group_event_id
      }
    });
  }

  sendReminder(){
    this.messageService.sendEventEmail(this.eventInfo.group_event_id,"Still time to register for this Golf Event.")
      .pipe(catchError((err)=>{
        console.log(err);
        return null;
      }))
      .subscribe( resp => {
        if (resp){
          this.error = "Message Sent."
        }
      })
  }

  isEventPaid(): boolean{
    //if tournament and eventPaymentStatus === 1
    //if not tournament and !expired and paymentStatus === '1'.
    if ( this.eventPaymentStatus && +this.eventPaymentStatus === 0){
      return false;
    }
    return true;
  }

  overallResults() {
    this.router.navigateByUrl('/results/'+this.eventInfo.multi_round_id);
  }

  getEventClass(){
    if ( this.short ){
      return "align-center";
    }
    return "";
  }

  expired(): boolean {
    if ( this.settings && this.settings.expiration_date ){
      let  expiration = Date.parse(this.settings.expiration_date);
      let now = Date.now();
      if (  now > expiration){
        return true;
      }
    }
    return false;
  }

  isTrip(){
    if ( this.settings && this.settings.group_type === '5'){
      return true;
    }
    return false;
  }

  submitPayment(){
    if ( this.settings && this.settings.group_type === '4'){
      this.eventService.getGroupMembershipDetails(this.settings.membership_level_id.toString())
        .subscribe( resp => {
          var membershipDetails : MembershipLevel = JSON.parse(resp.d)[0];
          var dialogRef = this.dialog.open(PaymentFormComponent, {
            width: '400px',
            data : { 
              amount : membershipDetails.price,
              frequency : membershipDetails.frequency
            }
          });

          dialogRef.afterClosed().subscribe( token => {
            if ( token ){
              this.requestSent = true;
              this.eventService.submitTournamentPayment(
                this.eventInfo.group_event_id, 
                token.id, 
                token.price, 
                membershipDetails.long_description,
                this.playerService.getLoggedInPlayerInfo().player_id.toString() )
                .subscribe( resp => this.processCcResponse(resp));
            }
          })
        });
    }else{
      this.router.navigateByUrl('group/console/'+this.eventInfo.group_id+'/4');
    }
  }

  isTournament(){
    if ( this.settings && this.settings.group_type === '4'){
      return true;
    }
    return false;
  }

  processCcResponse(resp){
    this.requestSent = false;
    var response = JSON.parse(resp.d).response;
    if ( response.status === 'succeeded' || response.status === 'active'){
      this.updatePaymentStatus();
      this.paymentStatusUpdated.emit('paymentStatusUpdated');
    }else{
      this.error = response.message;
    }
  }

  editEvent(){
    this.router.navigateByUrl('event/'+this.eventInfo.group_id+'/'+this.eventInfo.group_event_id+'/0');
  }

  verifyEvent(){
    this.router.navigateByUrl('event/verify/'+this.eventInfo.group_id+'/'+this.eventInfo.group_event_id);
  }

  showResults(){
    this.router.navigateByUrl('results/'+this.eventInfo.group_event_id);
  }

  groupSettings(){
    this.router.navigateByUrl('group/console/'+this.eventInfo.group_id+'/0')
  }

  isAdmin(){
    return this.canEditEvent;
  }

  showVerifyButton(){
    return this.router.url.indexOf('event/verify/') == -1 && this.canEditEvent && +this.eventInfo.is_multi_round !== 1;
  }

  showResultsButton(){
    return this.router.url.indexOf('results/') == -1 && this.canEditEvent;
  }

  showEditButton(){
    if ( this.canEditEvent){
      if ( this.router.url.indexOf('verify') !== -1 ||
           this.router.url.indexOf('results') !== -1 ||
           this.router.url.indexOf('info') !== -1){
             return true;
           }
    }
    return false;
  }

  isResultPage(){
    return this.router.url.indexOf('results/') !== -1;
  }

  isInfoPage(){
    return this.router.url.indexOf('info/') !== -1;
  }

  getScoringTypeText(){
    return this.eventInfo.scoring_name;
  }

  isRoundOfMultiRound(){
    if (this.eventInfo && +this.eventInfo.is_browsable === 0 && +this.eventInfo.is_multi_round === 0){
      return true;
    }
    return false;
  }

  getTwitterLink(){
    var url = window.location.href;
    return "https://twitter.com/intent/tweet?url="+url;
  }

  getFacebookLink(){
    var url = window.location.href;
    return "https://www.facebook.com/dialog/feed?app_id=1621065124651147&display=popup&redirect_uri="+url+"&link="+url;
  }

  editMasterEvent(){
    this.router.navigateByUrl('/event/'+this.masterEvent.group_id+'/'+this.masterEvent.group_event_id+'/4');
  }

  sendResultLinkEmail(){
    this.messageService.sendEventCompletedEmail(this.eventInfo.group_event_id)
      .subscribe( 
        success => {
        this.snackbar.open("Message Sent!",null, { panelClass: 'success-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
      },
      error =>{
        this.snackbar.open("Unable to send message, please try again later.",null, { panelClass: 'error-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
      }
    );
  }

  sendTeeTimesEmail(){
    
    dataLayer.push( {'event':'sendTeeTimesEmail'});
    this.messageService.sendTeeTimesEmail(this.eventInfo.group_event_id)
      .subscribe( 
        success => {
        this.snackbar.open("Message Sent!",null, { panelClass: 'success-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
      },
      error =>{
        this.snackbar.open("Unable to send message, please try again later.",null, { panelClass: 'error-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
      }
    );
  }


  addRoundToMultiRound(){
    var creatingEvent = true;
    var dialogRef = this.dialog.open(NewEventDialogComponent, {
      width: '650px',
      data : { 
        date : null, 
        player_id: this.playerService.getLoggedInPlayerInfo().player_id,
        group_id: +this.masterEvent.group_id,
        master_event_id: this.masterEvent.group_event_id,
        event_count: this.eventList.length+1
       }
    });

    dialogRef.afterClosed().subscribe( resp => {
      this.fetchRounds();
      creatingEvent = false;
    });
  }

  fetchRounds(){
    this.eventService.getRoundsFromMultiRounds(this.masterEvent.group_event_id)
      .subscribe( resp => this.eventList = JSON.parse(resp.d).rounds);
  }

  isLastRound(group_event_id){
    var event_index = this.eventList.findIndex(x => x.group_event_id == group_event_id);
    var event_count = this.eventList.length;
    if (event_index == event_count-1){
      return true;
    }
    return false;
  }

  isFirstRound(group_event_id){
    var event_index = this.eventList.findIndex(x => x.group_event_id == group_event_id);
    if (event_index == 0){
      return true;
    }
    return false;
  }

  nextRound(group_event_id){
    var next_event_index = this.eventList.findIndex(x => x.group_event_id == group_event_id)+1;
    var next_event = this.eventList[next_event_index];
    this.router.navigateByUrl("/event/"+next_event.group_id+"/"+next_event.group_event_id+"/0")
  }

  prevRound(group_event_id){
    var prev_event_index = this.eventList.findIndex(x => x.group_event_id == group_event_id)-1;
    var prev_event = this.eventList[prev_event_index];
    this.router.navigateByUrl("/event/"+prev_event.group_id+"/"+prev_event.group_event_id+"/0")
  }
}
